import { aboutStats, testimonials } from "@/mocks/baoliaoData";

export default function AboutSection() {
  return (
    <section id="about" className="py-10 md:py-16 bg-background-100/70 border-y border-background-200/60">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {/* narrative */}
          <div>
            <span className="inline-flex items-center gap-1.5 text-accent-600 text-xs font-semibold tracking-wider uppercase">
              <i className="ri-quill-pen-line"></i>
              关于我们
            </span>
            <h2 className="font-heading font-extrabold text-2xl md:text-3xl tracking-tight text-foreground-950 mt-2">
              做一本拿得出手的全网吃瓜说明书
            </h2>
            <p className="mt-4 text-sm md:text-[15px] leading-relaxed text-foreground-700">
              爆料网诞生于一个朴素的想法：信息越碎，越需要有人把它们拼起来。我们以实时爆料的快节奏为底色，用热点追踪的进度化梳理补齐来龙去脉，让每一个正在发酵的瓜，都能被快速、清楚又体面地读懂。
            </p>
            <p className="mt-3 text-sm md:text-[15px] leading-relaxed text-foreground-700">
              在内容原则上，我们坚持三件事：一是快而不躁，优先核实信源，核实不了就如实标注；二是全而有度，覆盖文娱体坛与生活百态，但边界清楚、不越界造谣；三是近而不扰，尊重当事人，审慎使用措辞，让热闹停在讨论的范畴内。
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-6">
              {aboutStats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-xl border border-background-200 bg-background-50 px-3 py-4 text-center"
                >
                  <p className="font-display text-xl md:text-2xl text-primary-600">{s.num}</p>
                  <p className="text-[11px] text-foreground-500 mt-1">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* community word of mouth */}
          <div>
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-heading font-extrabold text-lg text-foreground-950 flex items-center gap-2">
                <i className="ri-chat-heart-line text-primary-500"></i>
                大家怎么看我们
              </h3>
              <span className="inline-flex items-center gap-1 text-xs font-semibold text-foreground-700">
                <i className="ri-star-fill text-accent-500"></i>
                4.8 / 5 读者好评
              </span>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {testimonials.map((t, i) => (
                <figure
                  key={i}
                  className="rounded-2xl border border-background-200 bg-background-50 p-4 md:p-5"
                >
                  <div className="flex items-center gap-1 text-accent-500 text-xs">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <i key={j} className={j < t.stars ? "ri-star-fill" : "ri-star-line"}></i>
                    ))}
                  </div>
                  <blockquote className="mt-2.5 text-[13px] leading-relaxed text-foreground-700">
                    “{t.text}”
                  </blockquote>
                  <figcaption className="mt-3 flex items-center gap-2.5">
                    <span className="w-8 h-8 rounded-full bg-secondary-200 flex items-center justify-center text-secondary-800 font-bold text-xs">
                      {t.name.slice(0, 1)}
                    </span>
                    <span>
                      <span className="block text-xs font-semibold text-foreground-900">{t.name}</span>
                      <span className="block text-[11px] text-foreground-500">{t.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}